export default {
  "languages": {
    "en": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["English"])},
    "it": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Italiano"])}
  },
  "labels": {
    "kpis": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["KPIs"])},
    "search": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["cerca"])},
    "formula": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Formula"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Definizione"])},
    "dashboard": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dashboard"])},
    "summary": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Riepilogo"])},
    "page-title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["KPI"])},
    "modify": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Modifica"])},
    "delete": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Elimina"])},
    "cancel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Annulla"])}
  },
  "strings": {
    "delete-kpi-question": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sei sicuro di voler eliminare questo KPI?"])},
    "kpi-deleted": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["KPI eliminato"])}
  },
  "errors": {
    
  }
}